import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';

class DeleteDialog extends Component {

    constructor (props, context) {
        super(props);
        this.state = {
            open: false,
        };
        this.onDelete = this.onDelete.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.openDialog = this.openDialog.bind(this);
    }

    render() {

        const style = {
            zIndex: 9999,
        };

        const actions = [
            <FlatButton
                key="1"
                label="Cancel"
                onTouchTap={this.handleClose}
            />,
            <FlatButton
                key="2"
                label="Delete"
                onTouchTap={this.onDelete}
            />,
        ];

        let item;
        if(this.props.type === 'menu') {
            item = (
                <MenuItem
                    key='menuItem_1'
                    primaryText={this.props.menuTitle || 'Delete'}
                    leftIcon={this.props.menuLeftIcon || <DeleteIcon />}
                    onClick={this.openDialog}
                />
            );
        } else if(this.props.type === 'icon') {
            item = (
                <IconButton
                    key='iconButton_1'
                    tooltip="delete" onClick={this.openDialog}>
                    <DeleteIcon />
                </IconButton>
            );
        }

        return (
            <span style={style} >
                {item}
                <Dialog
                    key='dialog_1'
                    title={this.props.title}
                    actions={actions}
                    modal={false}
                    open={this.state.open}
                    onRequestClose={this.handleClose}
                >
                  {this.props.message}
                </Dialog>
            </span>
        )
    }

    onDelete() {
        this.props.onDelete(this.props.value);
    }

    handleClose() {
        this.setState({open: false});
    }
    openDialog(event){
        this.setState({open: true});
    }
}

DeleteDialog.propTypes = {
    type:     PropTypes.oneOf(['menu', 'icon']),
    title:    PropTypes.string.isRequired,
    message:  PropTypes.any.isRequired,
    value:    PropTypes.any.isRequired,
    onDelete: PropTypes.func.isRequired
};

export default DeleteDialog;
